import { supabase } from '../components/data/supabaseClient';

// Utility to check and ensure PackageActionsV2 database columns exist
export const checkAndMigratePackageDeliveryColumns = async () => {
  try {
    console.log('Checking PackageActionsV2 database columns...');
    
    // Test if the required columns exist by attempting to select them
    const { data, error } = await supabase
      .from('package_deliveries')
      .select('pickup_location_proof, delivery_location_proof, pickup_meeting_time, delivery_meeting_time, v2_enabled')
      .limit(1);

    if (error) {
      console.error('Database columns check failed:', error);
      return { success: false, error: error.message };
    }

    console.log('PackageActionsV2 database columns verified successfully');
    return { success: true, message: 'All required columns exist' };
    
  } catch (error) {
    console.error('Error checking database columns:', error);
    return { success: false, error: error.message };
  }
};

// Function to run the migration SQL manually if needed
export const runPackageDeliveryMigration = async () => {
  try {
    console.log('Running PackageActionsV2 database migration...');
    
    // First, check if we can run DDL statements
    const { data, error } = await supabase.rpc('check_admin_access');
    
    if (error) {
      console.error('Cannot run migration - admin access required:', error);
      return { 
        success: false, 
        error: 'Admin access required to run database migrations. Please run the SQL migration manually or contact your database administrator.' 
      };
    }

    // If we have admin access, we could run the migration here
    // For now, just return instructions
    return {
      success: false,
      error: 'Please run the database migration SQL manually. Check the database_migration.sql file in the PackageActionsV2 folder.'
    };

  } catch (error) {
    console.error('Error running migration:', error);
    return { success: false, error: error.message };
  }
};
